import type { EVENT_NAMES } from '@/constants';
import type { ActionData, BookPageData, ElementData, TextStyleData } from '@/types';
import mitt from 'mitt';

// mitt每个事件只有一个 payload，handler 永远只有一个参数,所以如果有多个参数，要封装成{}
type EventCallbackPayload = { resolve?: (meta?: any) => void; reject?: (err?: any) => void };

type MittEvent = {
  [EVENT_NAMES.TEST]: { value: number }; // 事件名称：事件参数
  [EVENT_NAMES.PROJECT_LOAD]: EventCallbackPayload;
  [EVENT_NAMES.PROJECT_PREVIEW_LOAD]: EventCallbackPayload;
  [EVENT_NAMES.BOOK_PAGE_ADD]: {
    pages: BookPageData[];
    resolve?: (meta?: any) => void;
    reject?: (err?: any) => void;
  };
  [EVENT_NAMES.BOOK_PAGE_REMOVE]: { ids: string[] };
  [EVENT_NAMES.BOOK_PAGE_THUMB_SYNC]: { pageId: string; sourceCanvas: HTMLCanvasElement };
  [EVENT_NAMES.BOOK_COVER_SYNC]: {
    resolve: (url: string | null) => void;
  };
  [EVENT_NAMES.BOOK_DISPLAY_SIZE_READY]: {
    left: number;
    top: number;
    width: number;
    height: number;
    containerWidth: number;
    containerHeight: number;
  };
  [EVENT_NAMES.ACTION_RELOAD]: { actionId: string; content: string };
  [EVENT_NAMES.ACTION_ADD]: ActionData;
  [EVENT_NAMES.EXPORT_PDF]: { filename?: string };
  [EVENT_NAMES.EXPORT_JPG]: { filename?: string; quality?: number };
  [EVENT_NAMES.ELEMENT_UPDATE]: ElementData;
  [EVENT_NAMES.APPLY_ALL_TEXTSTYLE]: TextStyleData;
  [EVENT_NAMES.BGM_ADD]: { url?: string; name?: string; volume?: number } | null;
  [EVENT_NAMES.WATERMARK_DIALOG_OPEN]: { resolve?: () => void };
  [EVENT_NAMES.BOOK_REPLAY]: undefined;
};

const emitter = mitt<MittEvent>();

export { emitter };
